<a
	class="bp-round-button bp-button-md min-width-auto"
	mat-flat-button
	color="primary"
	[outletLinkRelativeToRoot]="{ modal: ['subscription-management', { mode: 'upgrade' }] }"
>
	Upgrade {{ addMore ? 'To Add More' : 'Your Plan' }}
</a>
